/* eslint-disable fsecond/valid-event-listener */
import { useEffect } from 'react'
import Autocomplete from 'react-google-autocomplete'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'
import { IconButton } from '@velasca/ui/icon-button'
import { $page_bottega } from '@velasca/utils/globals'
import { sanitizeHTML } from '@velasca/utils/sanitize-html'
import { useBottega } from '../../BottegaProvider'

/**
 * This function triggers a keydown event for the Google Maps API when the user
 * presses Enter, NumpadEnter, or Tab.
 *
 * @param element - HTMLElement is a type of object that represents an HTML element in the Document Object Model (DOM). It can be any HTML element such as a div, span, input, etc.
 * @param e - The parameter "e" is a KeyboardEvent object, which contains information about a keyboard event such as the type of event, the key that was pressed, and any modifiers that were held down (e.g. Shift, ctrl).
 */
const handleKeyboardEvents = (element: HTMLElement, e: KeyboardEvent) => {
  if (e.code === 'Enter' || e.code === 'NumpadEnter' || e.code === 'Tab') {
    // Selects the first suggested option by pressing arrow down key
    google.maps.event.trigger(element, 'keydown', { keyCode: 40 })
    // Press enter
    google.maps.event.trigger(element, 'keydown', {
      keyCode: 13,
      triggered: true,
    })
  }
}

const Form = () => {
  const bottega = useBottega()

  useEffect(() => {
    const googleInput = document.querySelector<HTMLElement>(
      '#google-autocomplete',
    )

    if (!googleInput) {
      return
    }

    googleInput.addEventListener('keydown', (e) => {
      handleKeyboardEvents(googleInput, e)
    })

    return () => {
      googleInput.removeEventListener('keydown', (e) => {
        handleKeyboardEvents(googleInput, e)
      })
    }
  }, [])

  return (
    <div className="form col-md-8">
      <div className="inner row">
        <form
          className="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2"
          onSubmit={(e) => {
            e.preventDefault()
          }}
        >
          <h3
            dangerouslySetInnerHTML={sanitizeHTML($page_bottega.form_title)}
          ></h3>
          <div className="input">
            <Autocomplete
              id="google-autocomplete"
              types={['geocode']}
              placeholder={$page_bottega.form_placeholder}
              onPlaceSelected={(place: Record<string, unknown>) => {
                bottega?.setUserLocation(place)
              }}
            />
          </div>
        </form>
        <div className="scroll-down">
          <a href="#content">
            <IconButton>
              <ArrowDownIcon />
            </IconButton>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Form
